import { toast } from "react-toastify";
import {
    setCurrentLoop,
    setLoopThemes,
    addLoopTheme,
    updateLoopTheme,
    removeLoopTheme,
    setLoopKPIs,
    addLoopKPI,
    updateLoopKPI,
    removeLoopKPI,
    setLoopGoals,
    addLoopGoal,
    updateLoopGoal,
    removeLoopGoal,
    setLoopLayers,
    addLoopLayer,
    removeLoopLayer,
    setLoopSegments,
    addLoopSegment,
    updateLoopSegment,
    removeLoopSegment,
    setLoopLoading,
    setLoopError,
    clearLoopData,
} from "../slices/loopSlice.js";

import {
    addLoopThemeInProject,
    updateLoopThemeInProject,
    removeLoopThemeInProject,
    addLoopKPIInProject,
    updateLoopKPIInProject,
    removeLoopKPIInProject,
    addLoopLayerInProject,
    removeLoopLayerInProject,
    addLoopSegmentInProject,
    updateLoopSegmentInProject,
    removeLoopSegmentInProject,
    addLoopGoalInProject,
    updateLoopGoalInProject,
    removeLoopGoalInProject,
} from "../slices/projectsSlice.js";

import {
    fetchLoopThemes,
    createLoopTheme,
    updateLoopTheme as updateLoopThemeApi,
    deleteLoopTheme as deleteLoopThemeApi,
    fetchLoopKPIs,
    createLoopKPI,
    updateLoopKPI as updateLoopKPIApi,
    deleteLoopKPI as deleteLoopKPIApi,
    fetchLoopGoals,
    createLoopGoal,
    updateLoopGoal as updateLoopGoalApi,
    deleteLoopGoal as deleteLoopGoalApi,
    fetchLoopLayers,
    createLoopLayer,
    deleteLoopLayer as deleteLoopLayerApi,
    fetchLoopSegments,
    createLoopSegment,
    updateLoopSegment as updateLoopSegmentApi,
    deleteLoopSegment as deleteLoopSegmentApi,
    loadLoopData,
} from "../../utils/loopApi.js";

// Load all loop data
export const loadLoopDataAction = (loopId) => async (dispatch) => {
    try {
        dispatch(setLoopLoading(true));
        dispatch(setLoopError(null));
        
        const data = await loadLoopData(loopId);
        
        dispatch(setLoopThemes(data.themes));
        dispatch(setLoopKPIs(data.kpis));
        dispatch(setLoopGoals(data.goals));
        dispatch(setLoopLayers(data.layers));
        dispatch(setLoopSegments(data.segments));
        
        dispatch(setLoopLoading(false));
    } catch (error) {
        dispatch(setLoopError(error.message));
        dispatch(setLoopLoading(false));
        toast.error("Fout bij het laden van loop gegevens");
    }
};

// Loop Themes Actions
export const fetchLoopThemesAction = (loopId) => async (dispatch) => {
    try {
        dispatch(setLoopLoading(true));
        const themes = await fetchLoopThemes(loopId);
        dispatch(setLoopThemes(themes));
        dispatch(setLoopLoading(false));
    } catch (error) {
        dispatch(setLoopError(error.message));
        dispatch(setLoopLoading(false));
        toast.error("Fout bij het laden van loop thema's");
    }
};

export const createLoopThemeAction = (themeData) => async (dispatch) => {
    try {
        dispatch(setLoopLoading(true));
        const newTheme = await createLoopTheme(themeData);
        dispatch(addLoopTheme(newTheme));
        dispatch(addLoopThemeInProject(newTheme));
        dispatch(setLoopLoading(false));
        toast.success("Loop thema toegevoegd");
        return newTheme;
    } catch (error) {
        dispatch(setLoopError(error.message));
        dispatch(setLoopLoading(false));
        toast.error("Fout bij het maken van loop thema");
    }
};

export const updateLoopThemeAction = (themeId, themeData) => async (dispatch) => {
    try {
        const updatedTheme = await updateLoopThemeApi(themeId, themeData);
        dispatch(updateLoopTheme(updatedTheme));
        dispatch(updateLoopThemeInProject(updatedTheme));
        // toast.success("Loop thema bijgewerkt");
        return updatedTheme;
    } catch (error) {
        dispatch(setLoopError(error.message));
        toast.error("Fout bij het bijwerken van loop thema");
    }
};

export const deleteLoopThemeAction = (themeId) => async (dispatch) => {
    try {
        await deleteLoopThemeApi(themeId);
        dispatch(removeLoopTheme(themeId));
        dispatch(removeLoopThemeInProject(themeId));
        toast.success("Loop thema verwijderd");
    } catch (error) {
        dispatch(setLoopError(error.message));
        toast.error("Fout bij het verwijderen van loop thema");
    }
};

// Loop KPIs Actions
export const fetchLoopKPIsAction = (loopId) => async (dispatch) => {
    try {
        dispatch(setLoopLoading(true));
        const kpis = await fetchLoopKPIs(loopId);
        dispatch(setLoopKPIs(kpis));
        dispatch(setLoopLoading(false));
    } catch (error) {
        dispatch(setLoopError(error.message));
        dispatch(setLoopLoading(false));
        toast.error("Fout bij het laden van loop KPI's");
    }
};

export const createLoopKPIAction = (kpiData) => async (dispatch) => {
    try {
        const newKPI = await createLoopKPI(kpiData);
        dispatch(addLoopKPI(newKPI));
        dispatch(addLoopKPIInProject(newKPI));
        // toast.success("Loop KPI toegevoegd");
        return newKPI;
    } catch (error) {
        dispatch(setLoopError(error.message));
        toast.error("Fout bij het maken van loop KPI");
    }
};

export const updateLoopKPIAction = (kpiId, kpiData) => async (dispatch) => {
    try {
        const updatedKPI = await updateLoopKPIApi(kpiId, kpiData);
        dispatch(updateLoopKPI(updatedKPI));
        dispatch(updateLoopKPIInProject(updatedKPI));
        // toast.success("Loop KPI bijgewerkt");
        return updatedKPI;
    } catch (error) {
        dispatch(setLoopError(error.message));
        toast.error("Fout bij het bijwerken van loop KPI");
    }
};

export const deleteLoopKPIAction = (kpiId) => async (dispatch) => {
    try {
        dispatch(setLoopLoading(true));
        await deleteLoopKPIApi(kpiId);
        dispatch(removeLoopKPI(kpiId));
        dispatch(removeLoopKPIInProject(kpiId));
        dispatch(setLoopLoading(false));
        // toast.success("Loop KPI verwijderd");
    } catch (error) {
        dispatch(setLoopError(error.message));
        dispatch(setLoopLoading(false));
        toast.error("Fout bij het verwijderen van loop KPI");
    }
};

// Loop Goals Actions
export const fetchLoopGoalsAction = (loopThemeId) => async (dispatch) => {
    try {
        dispatch(setLoopLoading(true));
        const goals = await fetchLoopGoals(loopThemeId);
        dispatch(setLoopGoals(goals));
        dispatch(setLoopLoading(false));
    } catch (error) {
        dispatch(setLoopError(error.message));
        dispatch(setLoopLoading(false));
        toast.error("Fout bij het laden van loop doelen");
    }
};

export const createLoopGoalAction = (goalData) => async (dispatch) => {
    try {
        const newGoal = await createLoopGoal(goalData);
        dispatch(addLoopGoal(newGoal));
        dispatch(addLoopGoalInProject(newGoal));
        // toast.success("Loop doel toegevoegd");
        return newGoal;
    } catch (error) {
        dispatch(setLoopError(error.message));
        toast.error("Fout bij het maken van loop doel");
    }
};

export const updateLoopGoalAction = (goalId, goalData) => async (dispatch) => {
    try {
        // dispatch(setLoopLoading(true));
        const updatedGoal = await updateLoopGoalApi(goalId, goalData);
        dispatch(updateLoopGoal(updatedGoal));
        dispatch(updateLoopGoalInProject(updatedGoal));
        // dispatch(setLoopLoading(false));
        return updatedGoal;
    } catch (error) {
        dispatch(setLoopError(error.message));
        // dispatch(setLoopLoading(false));
        toast.error("Fout bij het bijwerken van loop doel");
    }
};

export const deleteLoopGoalAction = (goalId) => async (dispatch) => {
    try {
        // dispatch(setLoopLoading(true));
        await deleteLoopGoalApi(goalId);
        dispatch(removeLoopGoal(goalId));
        dispatch(removeLoopGoalInProject(goalId));
        // dispatch(setLoopLoading(false));
        toast.success("Loop doel verwijderd");
    } catch (error) {
        dispatch(setLoopError(error.message));
        // dispatch(setLoopLoading(false));
        toast.error("Fout bij het verwijderen van loop doel");
    }
};

// Loop Layers Actions
export const fetchLoopLayersAction = (loopId) => async (dispatch) => {
    try {
        dispatch(setLoopLoading(true));
        const layers = await fetchLoopLayers(loopId);
        dispatch(setLoopLayers(layers));
        dispatch(setLoopLoading(false));
    } catch (error) {
        dispatch(setLoopError(error.message));
        dispatch(setLoopLoading(false));
        toast.error("Fout bij het laden van loop lagen");
    }
};

export const createLoopLayerAction = (layerData) => async (dispatch) => {
    try {
        const newLayer = await createLoopLayer(layerData);
        dispatch(addLoopLayer(newLayer));
        dispatch(addLoopLayerInProject(newLayer));
        // toast.success("Loop onderdeel toegevoegd");
        return newLayer;
    } catch (error) {
        dispatch(setLoopError(error.message));
        // dispatch(setLoopLoading(false));
        toast.error("Fout bij het maken van loop onderdeel");
    }
};

export const deleteLoopLayerAction = (layerId) => async (dispatch) => {
    try {
        // dispatch(setLoopLoading(true));
        await deleteLoopLayerApi(layerId);
        dispatch(removeLoopLayer(layerId));
        dispatch(removeLoopLayerInProject(layerId));
        // toast.success("Loop onderdeel verwijderd");
    } catch (error) {
        dispatch(setLoopError(error.message));
        toast.error("Fout bij het verwijderen van loop onderdeel");
    }
};

// Loop Segments Actions
export const fetchLoopSegmentsAction = (loopId) => async (dispatch) => {
    try {
        dispatch(setLoopLoading(true));
        const segments = await fetchLoopSegments(loopId);
        dispatch(setLoopSegments(segments));
        dispatch(setLoopLoading(false));
    } catch (error) {
        dispatch(setLoopError(error.message));
        dispatch(setLoopLoading(false));
        toast.error("Fout bij het laden van loop dijkvakken");
    }
};

export const createLoopSegmentAction = (segmentData) => async (dispatch) => {
    try {
        dispatch(setLoopLoading(true));
        const newSegment = await createLoopSegment(segmentData);
        dispatch(addLoopSegment(newSegment));
        dispatch(addLoopSegmentInProject(newSegment));
        dispatch(setLoopLoading(false));
        toast.success("Loop dijkvak toegevoegd");
        return newSegment;
    } catch (error) {
        dispatch(setLoopError(error.message));
        dispatch(setLoopLoading(false));
        toast.error("Fout bij het maken van loop dijkvak");
    }
};

export const updateLoopSegmentAction = (segmentId, segmentData) => async (dispatch) => {
    try {
        dispatch(setLoopLoading(true));
        const updatedSegment = await updateLoopSegmentApi(segmentId, segmentData);
        dispatch(updateLoopSegment(updatedSegment));
        dispatch(updateLoopSegmentInProject(updatedSegment));
        dispatch(setLoopLoading(false));
        // toast.success("Loop dijkvak bijgewerkt");
        return updatedSegment;
    } catch (error) {
        dispatch(setLoopError(error.message));
        dispatch(setLoopLoading(false));
        toast.error("Fout bij het bijwerken van loop dijkvak");
    }
};

export const deleteLoopSegmentAction = (segmentId) => async (dispatch) => {
    try {
        dispatch(setLoopLoading(true));
        await deleteLoopSegmentApi(segmentId);
        dispatch(removeLoopSegment(segmentId));
        dispatch(removeLoopSegmentInProject(segmentId));
        dispatch(setLoopLoading(false));
        toast.success("Loop dijkvak verwijderd");
    } catch (error) {
        dispatch(setLoopError(error.message));
        dispatch(setLoopLoading(false));
        toast.error("Fout bij het verwijderen van loop dijkvak");
    }
};

// Utility Actions
export const setCurrentLoopAction = (loop) => (dispatch) => {
    dispatch(setCurrentLoop(loop));
};

export const clearLoopDataAction = () => (dispatch) => {
    dispatch(clearLoopData());
}; 